module.exports = __webpack_public_path__ + "img/farming_27.2675b30c.png";